var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgHeart = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "inherit",
  d: "M20.059 4.23c-2.14-1.876-5.324-1.538-7.29.547L12 5.593l-.77-.816c-1.96-2.085-5.148-2.423-7.288-.546-2.453 2.153-2.582 6.018-.387 8.353l7.559 8.027a1.2 1.2 0 0 0 1.77 0l7.558-8.027c2.199-2.335 2.07-6.2-.383-8.353"
})));
export default SvgHeart;